import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';

@Entity()
export class EmailAccountStats extends MongoEntity {
  static override _class = 'EmailAccountStats';
  static override _collectionName = 'email_account_stats';

  @Field(type => String) emailAccount!: string;
  @Field(type => String) campaignId!: string;
  @Field(type => String) userId!: string;
  @Field(type => Int) sent!: number;
  @Field(type => String) lastSyncedAt!: string;
}
